export default __webpack_public_path__ + "static/media/header-image.d55d4377.webp";